import { render } from "./PdfDialog.vue?vue&type=template&id=22ae2936"
import script from "./PdfDialog.vue?vue&type=script&lang=js"
export * from "./PdfDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__